import { Button, Modal, Paper, Stack } from "@mui/material";
import React from "react";
import styled from "styled-components";

const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",
    borderRadius: 4,
    boxShadow: 24,
    p: 4,
};

const H = styled.h1`
    font-size: 13px;
    font-weight: 500;
    color: ${({ theme }) => theme.palette.secondary.main};
    margin: 0;
`;

const P = styled.p`
    font-size: 12px;
    font-weight: 300;
    max-width: 95%;
    color: ${({ theme }) => theme.palette.secondary.main};
    padding-bottom: 16px;
    margin: 0;
`;

const FrameText = styled.p`
    font-size: 12px;
    font-weight: 300;
    color: ${({ theme }) => theme.palette.secondary.main};
    padding: 16px;
    margin: 0;
    background-color: #333333;
    border-radius: 9px;
`;

const EmbeddedModal = ({ open, handleClose, user }) => {
    const iFrameUrl = `<iframe width="1000" height="500" src="https://me.adadot.com/personal-profile/${user.orgId}:${user.user_id}" title="Adadot Personal Profile" allow="clipboard-write; web-share" scrolling="no" style="overflow: hidden; border: 0;" ></iframe>`;

    const handleCopy = () => {
        const textarea = document.createElement("textarea");
        textarea.value = iFrameUrl;
        document.body.appendChild(textarea);
        textarea.select();

        try {
            if (navigator.clipboard && typeof navigator.clipboard.writeText === "function") {
                navigator.clipboard
                    .writeText(iFrameUrl)
                    .then(() => {})
                    .catch((err) => {
                        console.error("Failed to copy URL to clipboard: ", err);
                    });
            } else {
                const isIOSDevice = /iPad|iPhone|iPod/.test(navigator.userAgent);
                if (isIOSDevice) {
                    const range = document.createRange();
                    range.selectNodeContents(textarea);
                    const selection = window.getSelection();
                    selection.removeAllRanges();
                    selection.addRange(range);
                    const successful = document.execCommand("copy");
                    if (successful) {
                        console.error("Copied URL to clipboard successfully");
                    } else {
                        console.error("Failed to copy URL to clipboard");
                    }
                } else {
                    console.error("Copying to clipboard is not supported in this browser.");
                }
            }
        } catch (err) {
            console.error("Unable to copy URL to clipboard: ", err);
        } finally {
            document.body.removeChild(textarea);
            handleClose();
        }
    };

    return (
        <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Paper sx={style}>
                <Stack direction="column" spacing={2}>
                    <H id="modal-modal-title" variant="h6" component="h2">
                        Embed your profile card
                    </H>
                    <P id="modal-modal-description" sx={{ mt: 2 }}>
                        Paste the code bellow to share your personal profile on your website or
                        social media page.
                    </P>
                    <FrameText id="modal-modal-description" sx={{ mt: 2 }}>
                        {iFrameUrl}
                    </FrameText>
                    <Stack
                        direction="row"
                        justifyContent="flex-end"
                        spacing={2}
                        style={{ width: "100%" }}
                    >
                        <Button color="secondary" size="medium" onClick={handleClose}>
                            Cancel
                        </Button>
                        <Button variant="contained" size="medium" onClick={handleCopy}>
                            Copy
                        </Button>
                    </Stack>
                </Stack>
            </Paper>
        </Modal>
    );
};

export default EmbeddedModal;
